import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';

import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';

import FilterToggle from 'components/filter-panel/FilterToggle';

const TableHeader = ({
  title,
  isShowFilterButton,
  initialFilter,
  filterOptions,
  actions,
  bulkActions,
  isBulkActionProcessing,
  onBulkActionApply,
}) => {
  const { getSelectedRowModel } = useAdvanceTableContext();
  const selectedRows = getSelectedRowModel().rows;
  const selectedRowsCount = selectedRows?.length || 0;

  return (
    <Row className="flex-between-center">
      <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
        <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
          {title}
          {selectedRowsCount > 0 && (
            <span className="text-500 ms-2">
              ({selectedRowsCount} selected)
            </span>
          )}
        </h5>
      </Col>
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
        {bulkActions && selectedRowsCount > 0 ? (
          <div className="d-flex gap-2">
            {bulkActions?.map(action => (
              <Button
                key={action.value}
                variant={action.variant || 'falcon-default'}
                className={action.className}
                size="sm"
                onClick={() => onBulkActionApply(action.value)}
                disabled={isBulkActionProcessing}
              >
                {isBulkActionProcessing ? 'Processing...' : action.label}
              </Button>
            ))}
          </div>
        ) : (
          <div
            id="table-actions"
            className="d-flex justify-content-end align-items-center gap-2"
          >
            {actions}
            {isShowFilterButton && filterOptions && (
              <FilterToggle initialFilter={initialFilter} />
            )}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default TableHeader;
